/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMultiplyScalar } from '../../factoriesAny.js';
export var multiplyScalarDependencies = {
  typedDependencies,
  createMultiplyScalar
};